// extracted by mini-css-extract-plugin
export default {"user":"OfferOfferGid_user__Us1Uz","firstOrder":"OfferOfferGid_firstOrder__TtZ0l"};